export class AssetNotFoundException extends Error {
    public constructor(message: string) {
        super(message);
    }
}
